import React from 'react';
import { Headline, Subtext } from '../../components/ScreenShell';
import { ChoiceCard } from '../../components/ui/Choice';
import { PrimaryButton } from '../../components/ui/PrimaryButton';
import { PRIORITIES_MAX, PRIORITY_OPTIONS } from '../../data/quizOptions';
import { useCopy } from '../../contexts/LanguageContext';
import { toggleValue } from '../../types/quiz';
import type { StepProps } from '../../types/quiz';
export function StepPriorities({
  profile,
  update,
  onNext
}: StepProps) {
  const copy = useCopy();
  const reachedMax = profile.development_priorities.length >= PRIORITIES_MAX;
  return <div className="flex flex-1 flex-col" data-id="element-156" data-mp="2tvgguz9nojav">
      <Headline data-id="element-157" data-mp="2twhpyy742vpy">{copy.steps.priorities.headline(profile.child_name)}</Headline>
      <Subtext data-id="element-158" data-mp="2ovbvovxsz0eb">
        {copy.steps.priorities.subtext(PRIORITIES_MAX)}{' '}
        <span className="font-semibold text-violet-600" data-id="element-159" data-mp="94688yugpild">
          {profile.development_priorities.length}/{PRIORITIES_MAX}
        </span>
      </Subtext>

      <div className="mt-6 space-y-3" data-id="element-160" data-mp="488qqp7gq670">
        {PRIORITY_OPTIONS.map(option => {
        const text = copy.options.priorities[option.key];
        return <ChoiceCard key={option.key} emoji={option.emoji} title={text.title} description={text.description} selected={profile.development_priorities.includes(option.key)} disabled={reachedMax} onSelect={() => update({
          development_priorities: toggleValue(profile.development_priorities, option.key, PRIORITIES_MAX)
        })} data-id="element-161" data-mp="1h0lihxcgeh8p" />;
      })}
      </div>

      <div className="mt-auto pt-10" data-id="element-162" data-mp="182t3kuan9blu">
        <PrimaryButton onClick={onNext} disabled={profile.development_priorities.length === 0} data-id="element-163" data-mp="amcfeupn5iop">
          {copy.quiz.continue}
        </PrimaryButton>
      </div>
    </div>;
}